var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitbucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "https://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: "svgr"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.778 1.211a.768.768 0 00-.768.892l3.263 19.811c.084.499.515.867 1.022.872H19.95a.772.772 0 00.77-.646l3.27-20.03a.768.768 0 00-.768-.891L.778 1.211zM14.52 15.528H9.522L8.17 8.464h7.561l-1.211 7.064z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwczovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0aXRsZT5CaXRidWNrZXQgaWNvbjwvdGl0bGU+PHBhdGggZD0iTS43NzggMS4yMTFjLS40MjQtLjAwNi0uNzcyLjMzNC0uNzc4Ljc1OCAwIC4wNDUuMDAyLjA5LjAxLjEzNGwzLjI2MyAxOS44MTFjLjA4NC40OTkuNTE1Ljg2NyAxLjAyMi44NzJIMTkuOTVjLjM4Mi4wMDQuNzA4LS4yNzEuNzctLjY0NmwzLjI3LTIwLjAzYy4wNjgtLjQxOC0uMjE2LS44MTMtLjYzNS0uODgxLS4wNDUtLjAwOC0uMDg5LS4wMTEtLjEzMy0uMDFMLjc3OCAxLjIxMXpNMTQuNTIgMTUuNTI4SDkuNTIyTDguMTcgOC40NjRoNy41NjFsLTEuMjExIDcuMDY0eiIvPjwvc3ZnPg==";
export { SvgBitbucket as ReactComponent };